// Which chat surface the Page drawer mounts. Flags default to false while
// the FeatureFlags query is in flight, and isFullAdmin reads false while the
// user query is, so choosing on either raw input would mount the legacy KB
// chat and then swap to the Opus Agent drawer once it lands — a
// wrong-surface flash for agent users on every load. Until BOTH the flags
// and the user identity are resolved, mount neither.
export type ChatSurface = "opus-agent" | "knowledge-base" | "none";

// The main content only "joins" the chat drawer (flush right edge) while a
// surface is actually mounted beside it — never while the surface is "none".
export const isChatJoined = ({
  shouldShowChat,
  chatSurface,
  chatOpen,
}: {
  shouldShowChat: boolean;
  chatSurface: ChatSurface;
  chatOpen: boolean;
}): boolean => shouldShowChat && chatSurface !== "none" && chatOpen;

export const resolveChatSurface = ({
  flagsResolved,
  userResolved,
  opusAgentEnabled,
  isFullAdmin,
}: {
  flagsResolved: boolean;
  userResolved: boolean;
  opusAgentEnabled: boolean;
  isFullAdmin: boolean;
}): ChatSurface => {
  if (!flagsResolved || !userResolved) return "none";
  return opusAgentEnabled && isFullAdmin ? "opus-agent" : "knowledge-base";
};
